import { WeekDayEnum } from "./WeekDayEnum.tsx";

export const WEEK_DAYS_IN_ORDER = Object.values(WeekDayEnum);

export const weekDayLabels: Record<WeekDayEnum, string> = {
  [WeekDayEnum.Monday]: "Lunedì",
  [WeekDayEnum.Tuesday]: "Martedì",
  [WeekDayEnum.Wednesday]: "Mercoledì",
  [WeekDayEnum.Thursday]: "Giovedì",
  [WeekDayEnum.Friday]: "Venerdì",
  [WeekDayEnum.Saturday]: "Sabato",
  [WeekDayEnum.Sunday]: "Domenica",
};

export const weekDayShortLabels: Record<WeekDayEnum, string> = {
  [WeekDayEnum.Monday]: "Lun",
  [WeekDayEnum.Tuesday]: "Mar",
  [WeekDayEnum.Wednesday]: "Mer",
  [WeekDayEnum.Thursday]: "Gio",
  [WeekDayEnum.Friday]: "Ven",
  [WeekDayEnum.Saturday]: "Sab",
  [WeekDayEnum.Sunday]: "Dom",
};

export function formatHour(hour: number): string {
  return `${String(hour).padStart(2, "0")}:00`;
}
